import React, {Component} from "react";
import {Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row,} from "reactstrap";
import StatusCircle from "../../components/StatusCircle";
import assets from "../../util/assets"

export default class AcceptAvailabilityModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            availabilityDetails: null,
            isFetching: false
        };
    }

    componentDidMount() {

        this.setState({
            availabilityDetails:
                this.props &&
                this.props.notificationData &&
                this.props.notificationData.success
                    ? this.props.notificationData.success.data
                    : this.props.notificationData && this.props.notificationData.data,
        });
    }

    getContent = (key) => {
        if (this.props && this.props.notificationData && this.props.notificationData.success) {
            return this.props.notificationData.success.data[key];
        } else if (this.props.notificationData) {
            return this.props.notificationData[key];
        } else {
            if (key === "image") {
                return assets.user_placeholder
            } else {
                return key;
            }
        }
    };

    getPrice = () => {
        let price = 0;
        if (this.props && this.props.notificationData && this.props.notificationData.hasOwnProperty("success")) {
            if (this.props.notificationData.success.hasOwnProperty("data") &&
                this.props.notificationData.success.data.hasOwnProperty("data") &&
                this.props.notificationData.success.data.data.hasOwnProperty("price")) {
                price = this.props.notificationData.success.data.data.price;
            }
        } else if (this.props && this.props.notificationData && this.props.notificationData.hasOwnProperty("data")) {
            if (this.props.notificationData.data.hasOwnProperty("price")) {
                price = this.props.notificationData.data.price;
            }
        }

        if (price === 0) {
            return "Free"
        } else {
            return `£ ${price} p/min`
        }
    };

    getMessage = () => {
        if (this.props.declineAvailabilityMessage &&
            this.props.declineAvailabilityMessage.hasOwnProperty("success") &&
            this.props.declineAvailabilityMessage.success.hasOwnProperty("message")) {
            return this.props.declineAvailabilityMessage.success.message;
        } else if (this.props.acceptAvailabilityRequestMessage &&
            this.props.acceptAvailabilityRequestMessage.hasOwnProperty("response") &&
            this.props.acceptAvailabilityRequestMessage.response.hasOwnProperty("error") &&
            this.props.acceptAvailabilityRequestMessage.response.error.hasOwnProperty("message")) {
            return this.props.acceptAvailabilityRequestMessage.response.error.message;
        } else {
            return "Session request will automatically expire if you didn't respond"
        }
    };

    render() {
        const awaitStyle = {
            awaitHead: {
                //height: "24px",
                //width: "196px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "18px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "24px",
                textAlign: "center",
            },
            awaitBody: {
                //height: "34px",
                //width: "312px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "12px",
                letterSpacing: "0",
                lineHeight: "17px",
                textAlign: "center",
                padding: "0% 9%",
            },
            okButton: {
                //height: "40px",
                //width: "136px",
                borderRadius: "2px",
                backgroundColor: "#1B75BC",
            },
            okButtonText: {
                //height: "19px",
                //width: "20px",
                color: "#FFFFFF",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
            userName: {
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "18px",
                fontWeight: 600,
                letterSpacing: 0,
                lineHeight: "24px",
            },
            sessiontext: {
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "14px",
                letterSpacing: 0,
                lineHeight: "22px",
            },
            priceContainer: {
                height: "40px",
                minWidth: "96px",
                maxWidth: "130px",
                borderRadius: "2px",
                backgroundColor: "#E9F2F8",
                textAlign: "center",
                margin: "0 auto",
            },
            price: {
                color: "#1B75BC",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: 600,
                letterSpacing: 0,
                lineHeight: "19px",
                margin: 0,
                padding: "10px",
            },
            cancelButtonText: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
            requestButtonText: {
                color: "#FFFFFF",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
            sessiontextCopy: {
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "12px",
                fontStyle: "italic",
                letterSpacing: 0,
                lineHeight: "22px",
                textAlign: "center",
            },
        };

        return (
            <Modal
                isOpen={this.props.showAcceptAvailabilityReqDialog}
                toggle={() => this.props.hideDialog()}
                centered
                style={{width: 450}}
            >
                <ModalHeader className="border-0 justify-content-center">
                    <div style={{position: "relative", width: "70px", margin: "0 auto"}}>
                        <img src={this.getContent("image")}
                             style={{width: 64, height: 64, borderRadius: "50%"}}/>
                        <StatusCircle status={"online"} onModal={true}/>
                    </div>
                </ModalHeader>
                <ModalBody className="justify-content-center">
                    <p style={awaitStyle.userName}>
                        {
                            this.getContent("title") === "title"
                                ?
                                "Fetching the notification..."
                                :
                                this.getContent("title")
                        }
                    </p>
                    {
                        this.getContent("title") === "title"
                            ?
                            <img alt={"loading"} src={assets.loading_blue_new} width={50}/>
                            :
                            <p style={awaitStyle.sessiontext}>
                                {this.getContent("body")}
                                <br/>
                                {this.getContent("session_title")}
                            </p>
                    }

                    <div style={awaitStyle.priceContainer}>
                        <p style={awaitStyle.price}>
                            {this.getPrice()}
                        </p>
                    </div>
                    <p style={awaitStyle.sessiontextCopy} className="mt-3">
                        {this.getMessage()}
                    </p>
                </ModalBody>
                <ModalFooter className="border-0 justify-content-center">
                    {this.props.declineAvailabilityMessage ||
                    this.props.acceptAvailabilityRequestMessage ? (
                        <Row className="mx-5">
                            <Col sm={12}>
                                <Button
                                    outline
                                    color="primary"
                                    className="px-5"
                                    onClick={() => {
                                        // this.props.declineAvailability();
                                        this.props.hideDialog();
                                    }}
                                >
                                    {
                                        this.state.isFetching
                                            ?
                                            <img src={assets.loading_blue} alt={"Loading"} width={25} height={25}/>
                                            :
                                            <span style={awaitStyle.cancelButtonText}>OK</span>
                                    }
                                </Button>
                            </Col>
                        </Row>
                    ) : (
                        <Row className="mx-5">
                            <Col sm={6}>
                                <Button
                                    outline
                                    color="primary"
                                    className="px-5"
                                    onClick={() => {
                                        this.props.declineAvailability();
                                    }}
                                >
                                    <span style={awaitStyle.cancelButtonText}>DECLINE</span>
                                </Button>
                            </Col>
                            <Col sm={6}>
                                <Button
                                    color="primary"
                                    className="text-capitalize"
                                    onClick={() => {

                                        this.setState({
                                            isFetching: true
                                        });

                                        this.props.acceptAvailability(
                                            this.props &&
                                            this.props.notificationData &&
                                            this.props.notificationData.success
                                                ? this.props.notificationData.success.data.type
                                                : this.props.notificationData &&
                                                this.props.notificationData.type
                                        );
                                    }}
                                >
                                    {
                                        this.state.isFetching ?
                                            <img src={assets.loading_white} alt={"Loading"} width={25} height={25}/>
                                            :
                                            <span style={awaitStyle.requestButtonText}>JOIN SESSION</span>
                                    }
                                </Button>
                            </Col>
                        </Row>
                    )}
                </ModalFooter>
            </Modal>
        );
    }
}
